module.exports = __webpack_public_path__ + "assets/images/project/satellite-images/meta-2-2018-desktop.jpg?v=f9f89bbd";